<template>
  <v-dialog
    class="thankyou-popup"
    rounded="pill"
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <v-card class="text-center pa-6">
      <!-- Success Icon -->
      <div class="d-flex justify-center mb-4">
        <img
          class="sucess-icon"
          src="@/assets/images/success-icon.svg"
          alt="sucess-order-icon"
        />
      </div>

      <div class="popup-content">
        <!-- Order Title -->
        <div class="popup-title">
          <span class="ord-label ml-2">מס' הזמנה</span>
          <span style="font-weight: 400">{{ ord }}</span>
        </div>

        <!-- Success Message -->
        <v-card-title class="success pa-0">
          הזמנתך התקבלה בהצלחה!
        </v-card-title>

        <!-- Service Message -->
        <v-card-text class="service pa-0 mb-8">
          צוות השירות שלנו עומד לרשותך כדי להבטיח את שביעות רצון המלאה.
          <span class="contact" @click="gotoHomePage"> צור קשר </span>
          <span class="text-grey-darken-1">לכל שאלה או בקשה נוספת.</span>
        </v-card-text>
      </div>

      <!-- Rating Section -->
      <v-sheet color="grey-lighten-4" class="mb-6 pa-4 sheet">
        <div v-if="!isUserRatingHasBeenSent">
          <div class="rating-title">חווית הקנייה באתר לשביעות רצונך?</div>
          <div class="rating-text">
            נשמח לדירוג כדי שנוכל לספק עבורכם חווית קניה נוחה ומיטבית.
          </div>
          <form @submit.prevent="submitRating">
            <div class="d-flex justify-center rating-container">
              <v-rating
                v-model="rating"
                color="#DCDCDC"
                active-color="amber"
                hover
                :size="$vuetify.display.xs ? 'small' : 'large'"
                :class="ratingClass"
                class="custom-rating"
              ></v-rating>
            </div>
            <div class="d-flex flex-column">
              <v-textarea
                v-if="isUserRatingReasonIsOpen"
                v-model="ratingReason"
                variant="outlined"
                class="pr-1 pl-1"
                :disabled="isSendRatingUserLoading"
                placeholder="נשמח לשמוע את הסיבה לדירוג"
                outlined
                dense
                maxlength="100"
                rows="2"
                hide-details
                auto-grow
                color="#bd9478"
              ></v-textarea>
              <span class="form-error-message mb-2">{{
                userRatingFormError
              }}</span>
            </div>
            <v-btn
              v-if="isUserRatingReasonIsOpen"
              :loading="isSendRatingUserLoading"
              class="btn-text mt-3"
              :class="{ 'w-100': isMobile }"
              flat
              color="#bd9478"
              type="submit"
              >שליחה</v-btn
            >
          </form>
        </div>
        <div v-else>
          <div class="sent-rating-title">הדירוג נשלח בהצלחה!</div>
        </div>
      </v-sheet>

      <!-- Action Button -->
      <div
        class="actions-buttons d-flex justify-space-between align-center"
        :class="{ 'flex-column justify-center ga-3': isMobile }"
      >
        <v-btn
          class="btn-text"
          :class="{ 'w-100': isMobile }"
          flat
          color="#bd9478"
          @click="gotoOrder"
        >
          צפייה בהזמנה
        </v-btn>
        <v-btn
          class="btn-text"
          :class="{ 'w-100': isMobile }"
          variant="outlined"
          color="#bd9478"
          @click="$router.push('/')"
        >
          חזרה לאתר
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ThankYouPopup",
  components: {},
  props: {
    userRatingFormError: {
      type: String,
      default: "",
    },
    isUserRatingHasBeenSent: {
      type: Boolean,
      default: false,
    },
    isSendRatingUserLoading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
    ord: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      rating: 0,
      dialog: this.value,
      isUserRatingReasonIsOpen: false,
      ratingReason: "",
    };
  },

  computed: {
    ...mapGetters({
      isMobile: "isMobile",
    }),
  },

  watch: {
    value(newVal) {
      this.dialog = newVal;
    },
    dialog(newVal) {
      this.$emit("input", newVal);
    },
    rating(ratingValue) {
      if (ratingValue >= 4) this.isUserRatingReasonIsOpen = false;
      else this.isUserRatingReasonIsOpen = true;
    },
  },

  methods: {
    submitRating() {
      this.$emit("rate", { rating: this.rating, reason: this.ratingReason });
    },
    async gotoHomePage() {
      if (this.$router.name !== "home") {
        await this.$router.push("/");
      }
      const element = document.getElementById("contact");
      if (element) {
        this.$nextTick(() => {
          element.scrollIntoView({ behavior: "smooth" });
        });
      }
    },
    gotoOrder() {
      this.$router.push("account/orders/" + this.ord);
    },
    closeDialog() {
      this.dialog = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
.form-error-message {
  color: #f44336;
  font-size: 16px;
  margin-top: 5px;
}
.thankyou-popup {
  .v-card {
    padding: 50px !important;
    border-radius: 20px !important;
  }
  .sheet {
    border-radius: 10px !important;
  }
  .v-btn__content {
    font-size: 18px;
  }

  @media (max-width: 601px) {
    .v-card {
      padding: 30px !important;
    }
  }
}
</style>

<style lang="scss" scoped>
.contact {
  color: #9100b5 !important;
  text-decoration: underline;
  cursor: pointer;
}
.rating-title {
  font-size: 20px;
  font-weight: 700;
}
.sent-rating-title {
  font-size: 20px;
  color: #4caf50;
  font-weight: 700;
}
.rating-text {
  font-size: $mediumTextSize;
  font-weight: 400;
  color: $DeepGray;
}
.success {
  font-size: 20px;
  font-weight: 700;
}
.service {
  font-size: $mediumTextSize;
  color: $DeepGray;
  font-weight: 400;
}
.contact {
  font-size: $mediumTextSize;
  color: $DeepGray;
  font-weight: 400;
}
.ord-label {
  color: #bd9478;
  color: $greenColor;
}
.popup-title {
  font-size: $h1TextTitleSize;
  font-weight: 700;
}
.btn-text {
  font-size: 16px;
  font-weight: 300;
}

/* RTL Support */
:deep(.v-card) {
  direction: rtl;
}

/* Rating stars styling */
:deep(.v-rating .v-rating__wrapper) {
  gap: 12px;
}

:deep(.v-rating .v-rating__item .v-btn) {
  padding: 0;
  transform: scale(1.4); /* Makes the stars bigger while maintaining the gap */
}

:deep(.rating-container) {
  padding: 10px 0; /* Add some vertical padding to accommodate larger stars */
}

/* Link styling */
.text-decoration-underline {
  text-decoration: underline !important;
}

/* Order ID label styling */
.ordIdLabel {
  margin-right: 8px;
}

.rating-class {
  --rating-size: 24px;
}

@media (min-width: 600px) {
  .rating-class {
    --rating-size: 32px;
  }
}

@media (min-width: 960px) {
  .rating-class {
    --rating-size: 48px;
  }
}

@media (max-width: 601px) {
  .sucess-icon {
    width: 50%;
  }
}

.v-rating {
  transform: scale(calc(var(--rating-size) / 24));
  transform-origin: left center;
}
</style>
